<template>
    <div class="payment-form">
        <div class="form-row">
            <div :id="'card-element-' + _uid"></div>
            <div id="card-errors" role="alert" v-if="error" v-text="error.message"></div>
        </div>
    </div>
</template>
<script>
    export default {

        props:{
            thru:{
                type: String,
                required: false,
                default: ''
            },
            cardSetup:{
                type: Boolean,
                default: false,
                required: false,
            }
        },

        data() {
            return {
                stripe: null,
                elements: null,
                card: null,
                error: null,
            }
        },

        mounted() {
            this.elements = this.stripe.elements();
            var style = {
                base: {
                    fontSmoothing: 'antialiased',
                    fontSize: '16px',
                    '::placeholder': {
                        color: '#aab7c4'
                    }
                },
                invalid: {
                    color: '#fa755a',
                    iconColor: '#fa755a'
                }
            };
            this.card = this.elements.create('card', {style});
            this.card.mount('#card-element-' + this._uid);
            this.card.addEventListener('change', event => {
                this.error = event.error;
            });
        },

        methods: {
            submitPayment(client, details) {
                this.stripe.confirmCardPayment(client.secret, {
                    payment_method: {
                        card: this.card,
                        billing_details: details
                    }
                }).then(result => {
                    if (result.error) {
                        this.$emit('error', result.error.message);
                        this.card.clear()
                    } else {
                        if (result.paymentIntent.status === 'succeeded') {
                            this.$emit('success', result)
                        }
                    }
                });
            },

            async addPaymentMethod(client) {
                const {setupIntent, error} = await this.stripe.confirmCardSetup(
                    client.secret, {
                        payment_method: {
                            card: this.card,
                            billing_details: {name: client.name}
                        }
                    }
                );

                if (error) {
                    this.$emit('error', error);
                    this.card.clear()
                } else {
                    this.$emit('success', setupIntent.payment_method);
                }
            }
        },

        created() {
            this.stripe = Stripe(App.config.stripe.key);
            App.bus.$on('checkout-form', this.submitPayment);
            App.bus.$on('add-payment-method-form', this.addPaymentMethod);
        }
    }
</script>
